import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {AgentIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useRef} from 'react'

import {AgentSessionsSidePanel} from './AgentSessionsSidePanel'
import {DockedPanel, useDockedPanelActions, useIsDockedPanelOpen} from '../../contexts/DockedPanelContext'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {Repository} from '@github-ui/current-repository'

export interface OpenAgentsSidePanelButtonProps {
  repository: Repository
  pullRequestNumber: number
}

export const ICON_BUTTON_LABEL = 'Open agent sessions panel'

export function OpenAgentsPanelButton({repository, pullRequestNumber}: OpenAgentsSidePanelButtonProps) {
  const isCodingAgentLogsInPrEnabled = isFeatureEnabled('coding_agent_logs_in_pr')
  const isPrsDockedSidePanelEnabled = isFeatureEnabled('prs_docked_side_panel')
  const isDockedPanelOpen = useIsDockedPanelOpen(DockedPanel.AgentSessions)
  const toggleSidePanelRef = useRef<HTMLButtonElement>(null)
  const actions = useDockedPanelActions()

  if (!isCodingAgentLogsInPrEnabled || !isPrsDockedSidePanelEnabled) {
    return null
  }

  return (
    <div className="d-flex flex-items-center">
      <ErrorBoundary
        boundaryName="OpenAgentsSidePanelButton"
        fallback={
          <IconButton
            inactive
            aria-label="The agent sessions panel cannot currently be opened."
            icon={AgentIcon}
            size="small"
            variant="invisible"
          />
        }
      >
        <IconButton
          ref={toggleSidePanelRef}
          aria-label={ICON_BUTTON_LABEL}
          icon={AgentIcon}
          size="small"
          variant="invisible"
          onClick={() => {
            actions.togglePanel('agentSessions', toggleSidePanelRef.current)
          }}
        />
        <AgentSessionsSidePanel
          isOpen={isDockedPanelOpen}
          repository={repository}
          pullRequestNumber={pullRequestNumber}
        />
      </ErrorBoundary>
    </div>
  )
}
